<app-alert level="danger" *ngIf="error">{{error}}</app-alert>

<p>
    <a [routerLink]="['/course-equalizations'] | localize" target="_blank">
        {{'planSummary_courseEqualization' | translate}}
        <i class="fi fi-rs-arrow-right"></i>
    </a>
</p>

<section class="block" *ngIf="isLoaded">
    <header class="block-header">
        <h5>{{'planSummary_courses_schedule' | translate}}</h5>
        <aside>
            <input class="form-control"
                   (input)="filterScheduler($event)"
                   [placeholder]="'planSummary_lblFilter' | translate">
        </aside>
    </header>

    <div class="chart">
        <bryntum-scheduler-pro #scheduler
                               [columns]="schedulerConfig.columns"
                               [features]="schedulerConfig.features"
                               [startDate]="schedulerConfig.startDate"
                               [endDate]="schedulerConfig.endDate"
                               [visibleDate]="schedulerConfig.visibleDate"
                               [weekStartDay]="schedulerConfig.weekStartDay"
                               [readOnly]="schedulerConfig.readOnly"
                               [resources]="schedulerModel.resources"
                               [events]="schedulerModel.events"
                               [assignments]="schedulerModel.assignments"></bryntum-scheduler-pro>
    </div>
</section>

<section class="block" *ngIf="isLoaded">
    <header class="block-header">
        <h5>{{'planSummary_courses_list' | translate}}</h5>
        <aside>
            <input class="form-control"
                   (input)="searchCourses($event)"
                   [placeholder]="'planSummary_lblSearch' | translate"
                   maxlength="50"
                   [disabled]="total < 1">
        </aside>
    </header>

    <app-alert level="info" *ngIf="total == 0">{{'planSummary_courses_empty' | translate}}</app-alert>

    <div *ngFor="let g of coursesByYear">
        <div class="text-top mb-2">
            <span (click)="util.toggle(g)" class="course-year-label">
                {{g.year}}{{'planSummary_yearPostfix' | translate}}
                <i class="fi fi-rs-angle-circle-{{util.isExpanded(g) ? 'down' : 'right'}}"></i>
            </span>
        </div>

        <app-table [columns]="rotationColumns" [rows]="g.courses" pageSize="20" *ngIf="util.isExpanded(g)">
            <ng-template #rowTemplate let-row>
                <tr>
                    <td>
                        <div>
                            <app-course-details-link [code]="row.Code" [name]="row.fullName"></app-course-details-link>
                        </div>
                        <div class="text-sub hidden-lg-up">
                            <div class="hidden-md-up">
                                <label>{{'planSummary_courses_lblDateFromTo' | translate}}:</label>
                                {{row.DateFrom | appDate}} - {{row.DateTo | appDate}} ({{row.WeekCount}} {{weeksPostfix}})
                            </div>
                            <div>
                                <label>{{'planSummary_courses_lblLecturers' | translate}}:</label>
                                {{row.lecturerString}}
                            </div>
                            <div>
                                <label>{{'planSummary_courses_lblPlace' | translate}}:</label>
                                {{row.CompanyName ?? ('planSummary_courses_lblPlaceUndefined' | translate)}}
                            </div>
                            <div>
                                <label>{{'planSummary_courses_lblEcts' | translate}}:</label>
                                {{row.Ects}}
                            </div>
                        </div>
                    </td>
                    <td class="hidden-sm-down">
                        <div>{{row.DateFrom | appDate}} - {{row.DateTo | appDate}}</div>
                        <div class="text-sub">{{row.WeekCount}} {{weeksPostfix}}</div>
                    </td>
                    <td class="hidden-md-down">
                        <div>{{row.lecturerString}}</div>
                        <div class="text-sub">{{row.CompanyName ?? ('planSummary_courses_lblPlaceUndefined' | translate)}}</div>
                    </td>
                    <td class="hidden-md-down">{{row.Ects}}</td>
                    <td>
                        <div class="table-actions">
                            <button type="button"
                                    *ngIf="row.isGradingActive"
                                    class="btn btn-outline btn-icon"
                                    (click)="addGrade(row)"
                                    [ngbTooltip]="'planSummary_courses_setGrade' | translate">
                                <i class="fi fi-rs-text-check"></i>
                            </button>

                            <button type="button" class="btn btn-outline btn-icon" (click)="addLecturer(row)"
                                    [disabled]="!row.IsActive || row.IsFinal"
                                    [ngbTooltip]="'planSummary_courses_addLecturer' | translate">
                                <i class="fi fi-rs-user-add"></i>
                            </button>

                            <button type="button" class="btn btn-outline btn-icon" (click)="removeLecturer(row)"
                                    [disabled]="!row.IsActive || !row.Lecturers.length || row.IsFinal"
                                    [ngbTooltip]="'planSummary_courses_removeLecturer' | translate">
                                <i class="fi fi-rs-remove-user"></i>
                            </button>
                        </div>
                    </td>
                </tr>
                <tr class="notes-row" *ngIf="row.Notes">
                    <td colspan="9">
                        <div>
                            <i class="fi fi-rs-comment"></i>
                            {{row.Notes}}
                        </div>
                    </td>
                </tr>
                <tr class="grade-row" *ngIf="row.gradeGroups.length">
                    <td colspan="9">
                        <div class="grade-list">
                            <div *ngFor="let group of row.gradeGroups" class="grade-group">
                                <label>{{group.title}}</label>
                                <table>
                                    <tr *ngFor="let g of group.grades">
                                        <td>
                                            <div class="grade-lecturer">
                                                <i class="fi fi-rs-user"></i>
                                                {{g.lecturer}}
                                            </div>
                                            <div class="hidden-sm-up text-nowrap">
                                                <i class="fi fi-rs-calendar-check"></i>
                                                {{g.date | appDate}}
                                            </div>
                                        </td>
                                        <td class="text-nowrap hidden-xs-down">
                                            <i class="fi fi-rs-calendar-check"></i>
                                            {{g.date | appDate}}
                                        </td>
                                        <td class="text-nowrap hidden-sm-down" *ngIf="g.practice">
                                            <i class="fi fi-rs-syringe"></i>
                                            {{'planSummary_courses_lblPractice' | translate}}: {{g.practice}}
                                        </td>
                                        <td class="text-nowrap hidden-sm-down" *ngIf="g.theory">
                                            <i class="fi fi-rs-notebook"></i>
                                            {{'planSummary_courses_lblTheory' | translate}}: {{g.theory}}
                                        </td>
                                        <td class="hidden-sm-down" *ngIf="g.test">
                                            <i class="fi fi-rs-shield-check"></i> {{g.test}}
                                        </td>
                                        <td class="hidden-md-up">
                                            <div *ngIf="g.practice" class="text-nowrap">
                                                <i class="fi fi-rs-syringe"></i>
                                                {{'planSummary_courses_lblPractice' | translate}}: <strong>{{g.practice}}</strong>
                                            </div>

                                            <div *ngIf="g.theory" class="text-nowrap">
                                                <i class="fi fi-rs-notebook"></i>
                                                {{'planSummary_courses_lblTheory' | translate}}: <strong>{{g.theory}}</strong>
                                            </div>

                                            <div *ngIf="g.test">
                                                <i class="fi fi-rs-shield-check"></i> {{g.test}}
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </td>
                </tr>
            </ng-template>
        </app-table>
    </div>
</section>

<section class="block" *ngIf="isLoaded">
    <header class="block-header">
        <h5>{{'planSummary_absences' | translate}}</h5>
    </header>

    <app-table [columns]="absenceColumns" [rows]="absences" pageSize="100">
        <ng-template #rowTemplate let-row>
            <tr>
                <td>{{'planSummary_absences_type' + row.Type | translate}}</td>
                <td>
                    <div>{{row.DateFrom | appDate}} - {{row.DateTo | appDate}}</div>
                    <div class="text-sub">{{row.WeekCount}} {{weeksPostfix}}</div>
                </td>
            </tr>
        </ng-template>
    </app-table>
</section>
